import { DEFAULT_PAGE, DEFAULT_ROWS_PER_PAGE } from "constants/paginationConstants";
import { atom } from "jotai";

export const customerFiltersAtom = atom({
  fullName: "",
  phoneNumber: "",
  email: "",
  status: [],
});

export const customerPageAtom = atom(DEFAULT_PAGE); 
export const customerRowsPerPageAtom = atom(DEFAULT_ROWS_PER_PAGE); 

export const descendingNameSortAtom = atom(null);
export const descendingEmailSortAtom = atom(null);


